import React from 'react';
//import fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCog, faGift, faUsers, faBlog, faFileAlt, faKey, faTags, faPencilAlt, faChartBar } from '@fortawesome/free-solid-svg-icons'; // Import specific icons
import { Link, useNavigate } from 'react-router-dom';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons'; // Import the Level icon
import { useGlobalContext } from './../../GlobalContext';

function SideBar() {
    const {
        isLoading, setIsLoading,
        isAppError, setAppError,
        appErrorMessage, setAppErrorMessage,
        appErrorTitle, setAppErrorTitle,
        appErrorMode, setAppErrorMode,
        appUser, setAppUser,
        isLogin, setIsLogin,
        isLogoutRequest, setIsLogoutRequest
    } = useGlobalContext();

    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("oojwt");
        setIsLogin(false);
        setAppUser(null);
        setIsLogoutRequest(true); // if used anywhere else
        navigate('/login');
    };
    return (
        <>
            <aside id='sidebar' className='sidebar'>
                <ul className='sidebar-nav' id='sidebar-nav'>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/'>
                            <i><FontAwesomeIcon icon={faHome} /></i>
                            <span>Dashboard</span>
                        </Link>
                    </li>

                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#setting-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faCog} /></i>
                            <span>Settings</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='setting-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li className="d-none">
                                <Link to='/setting/branding'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Genders</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='setting/country/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Countrys</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='setting/state/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>States</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/setting/citys'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Cities</span>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#gift-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faGift} /></i>
                            <span>Award</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='gift-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/gift/add'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Add</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/gift/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Search</span>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#level-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faLayerGroup} /></i> {/* Add the Level icon */}
                            <span>Level</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='level-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/level/add'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Add</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/level/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Search</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#brand-officer-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faUsers} /></i>
                            <span>Members</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='brand-officer-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/members/add'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Add</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/members/list/free'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Free Members</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/members/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Active Members</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/members/list/inactive'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>In-Active Members</span>
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#epin-purchase-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faLayerGroup} /></i> {/* Add the Level icon */}
                            <span>Epin Purchase</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='epin-purchase-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/epinpurchase/add'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Add</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/epinpurchase/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Search</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#blog-cat-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faTags} /></i>
                            <span>Blog Category</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='blog-cat-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/blogcategory/add'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Add</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/blogcategory/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Search</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#blog-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faPencilAlt} /></i>
                            <span>Blog</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='blog-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">

                            <li>
                                <Link to='/blog/add'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Add</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/blog/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Search</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#page-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faFileAlt} /></i>
                            <span>Page</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='page-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/page/add'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Add</span>
                                </Link>
                            </li>
                            <li>
                                <Link to='/page/list'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Search</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/reports/level'>
                            <i><FontAwesomeIcon icon="fa-solid fa-list" /></i>
                            <span>Level Report</span>
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/tree'>
                            <i><FontAwesomeIcon icon="fa-solid fa-chart-diagram" /></i>
                            <span>Tree View</span>
                        </Link>
                    </li>
                    {/*
                    <li className='nav-item'>
                        <Link className='nav-link collapsed' data-bs-target="#reports-nav" data-bs-toggle="collapse" to='#'>
                            <i><FontAwesomeIcon icon={faChartBar} /></i>
                            <span>Reports</span>
                            <i className='bi bi-chevron-down ms-auto'></i>
                        </Link>
                        <ul id='reports-nav' className='nav-content collapse' data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to='/reports/level'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Level Report</span>
                                </Link>
                            </li>
                            <li className="d-none">
                                <Link to='/gift/given'>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
                                    <span>Gift Giving</span>
                                </Link>
                            </li>
                        </ul> 
                    </li>
                    */}
                    <hr></hr>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/myprofile'>
                            <i className='bi bi-person'></i>
                            <span>My Profile</span>
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/mypassword'>
                            <i className='bi bi-key'></i>
                            <span>My Password</span>
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' onClick={handleLogout} >
                            <i className='bi bi-lock'></i>
                            <span>Sign Out</span>
                        </Link>
                    </li>
                </ul>
            </aside>
        </>
    )
}

export default SideBar;